import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IAugmentedJQuery, IController, ILocationService, IModule, IOnChangesObject, IPromise, IQService, IScope, ITimeoutService, IWindowService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {fraJson} from "felles/stoettefunk/json";
import {InnlastingsindikatorKontroller} from "../../../basis/direktiver/innlastingsindikator";
import {DashboardFilterKontroller} from "../dashboardFilter/dashboardFilter";
import {TemaRessurs} from "felles/tjenester/ressurser/TemaRessurs";
import {SakstypeRessurs} from "felles/tjenester/ressurser/SakstypeRessurs";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {Debugger} from "debug";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {ÅrshjulRessurs} from "felles/tjenester/ressurser/ÅrshjulRessurs";
import {RedigerÅrshjulinnslagDialog} from "../årshjul/redigerÅrshjulinnslagDialog";
import {MånedInfo, MøteInfo, MøterIPlanModell} from "./MøterIPlanModell";
import {Gruppeinfo, GrupperingsEntitet, SakerIPlanModell, SaksgruppeInfo, SaksgruppeType} from "./sakerIPlanModell";
import {MøteTjeneste} from "web/moduler/møte/MøteTjeneste";
import {dateSomPlainDate, dateSomZonedDateTime} from "felles-ng2/støttefunksjoner/temporalTilDateKonverteringer";
import {DatoPerioder} from "felles/stoettefunk/datoPerioder";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {gjeldendeTidssoneStatisk, Tidssoneinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import IResourceArray = ng.resource.IResourceArray;
import {GruppeId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeOgPeriode} from "web-ng2/moduler/plan/komponenter/protokoller-med-behandlinger-listing/protokoller-med-behandlinger-listing";
import {scrollTilTopp} from "felles/stoettefunk/scroll";
import {ZonedDateTimePeriodeLukket} from "felles-ng2/typer/ZonedDateTimePeriode";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";

require('twix'); //utvider moment
require('./planer.scss');

const debug: Debugger = require('debug')('PlanerKontroller');

export class PlanerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmDashboardPlaner', {
              bindings: {filter: '<'},
              controller: PlanerKontroller.forInjisering(),
              template: require('./planer.html')
          })
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$q,
            regNavn.ng.$timeout,
            regNavn.ng.$element,
            regNavn.ng.$window,
            regNavn.ng.$location,
            regNavn.ng.ui.$state,
            regNavn.md.$mdDialog,
            IntroJsTjeneste.regNavn,
            Kontekst.regNavn,
            MøteRessurs.regNavn,
            MøteTjeneste.regNavn,
            TemaRessurs.regNavn,
            SakstypeRessurs.regNavn,
            ÅrshjulRessurs.regNavn,
            GruppeRessurs.regNavn,
            WebNavigasjon.regNavn,
            regNavn.gettext.gettextCatalog,
            PlanerKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $q: IQService,
                private $timeout: ITimeoutService,
                private $element: IAugmentedJQuery,
                private $window: IWindowService,
                private $location: ILocationService,
                private $state: StateService,
                private $mdDialog: angular.material.IDialogService,
                private introJs: IntroJsTjeneste,
                private kontekst: Kontekst,
                private møteRes: MøteRessurs,
                private møteTjeneste: MøteTjeneste,
                private temaRes: TemaRessurs,
                private sakstypeRes: SakstypeRessurs,
                private årshjulRessurs: ÅrshjulRessurs,
                private gruppeRes: GruppeRessurs,
                private navigasjon: WebNavigasjon,
                private gettextCatalog: gettextCatalog) {

        this.resizeLytter = <any>_.debounce(() => this.$scope.$apply(() => this.håndterEndringIVindusstørrelse()), 500); //reager på vindus skalering maks hvert 2. sekund
        this.årshjulinnslagLaster = this.$q.resolve({});
        this.lastÅrshjulinnslagMem = _.memoize(gruppeId => this.årshjulRessurs.hentAlle(gruppeId)); //sørger for å cache kall til årshjulRessurs.hentAlle
    }

    filter: l.DashboardFiltervalg; //settes via bindings/$onChanges

    laster = false;
    plan: MøterIPlanModell;
    saker: SakerIPlanModell;

    periodeTittel: string;
    visningsmodus: 'matrise' | 'saksliste' | 'protokollbehandlinger' = 'matrise';
    viserInnevaerendePlan = true;
    protokollbehandlingerUtvalg: GruppeOgPeriode & {gruppe: l.EnkelGruppeModell} | null = null

    private møter: l.MøteModellEnkel[] = null;
    /** Map med sist lastede møtedetaljer per gruppe */
    private lastedeMøtedetaljer: { [gruppeId: string]: l.MøteModell[] } = {}

    private resizeLytter: () => void;
    private årshjulinnslagLaster: IPromise<{ [gruppeId: string]: l.ÅrshjulInnslagModell[] }>;
    private lastÅrshjulinnslagMem: (gruppeId: string) => IResourceArray<l.ÅrshjulInnslagModell>;

    skaler(månedInfo: MånedInfo, verdi: number, øvreGrense = Number.MAX_SAFE_INTEGER): number {
        return Math.min(månedInfo.skalering * verdi, øvreGrense);
    }

    ingenMoeter() {
        return this.møter && _.isEmpty(this.møter);
    }

    antallGrupperFiltrertBort() {
        if (!this.filter) return 0; //filter er muligens ikke satt enda
        return this.kontekst.autentiserteGrupper().length - this.filter.gruppeIder.length;
    }

    nyttMoeteIMnd(måned: MånedInfo, gruppeId: string) {
        this.møteTjeneste.nyttMøteDialog(gruppeId, dateSomPlainDate(måned.mnd));
    }

    nyttMoeteEtterMoete(møteInfo: MøteInfo) {
        let møtedato = dateSomPlainDate(møteInfo.moete.dato.slutt);
        //initier opprett-møte-dialog med dato satt til dagen etter angitt møte
        if (møtedato.day < møtedato.daysInMonth) møtedato = møtedato.add({days: 1});
        this.møteTjeneste.nyttMøteDialog(møteInfo.moete.eiendeGruppeId, møtedato);
    }

    visSkjulDetaljer(gruppeinfo: Gruppeinfo) {
        if (!gruppeinfo.saksgrupperinger) {
            InnlastingsindikatorKontroller.visIndikator(this.$scope.$root);
            this.lastDetaljerForGrupper([gruppeinfo.gruppe.id])
              .finally(() => InnlastingsindikatorKontroller.skjuleIndikator(this.$scope.$root));
        } else
            gruppeinfo.viserSaker = !gruppeinfo.viserSaker;

        this.persisterEkspanderteGrupperUtvalg();
    }

    visForrigePeriode() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visForrigePeriode)
    }

    visNestePeriode() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visNestePeriode)
    }

    gaaTilInevaerendePlan() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visInnværendePeriode)
    }

    opphevTrunkeringStart() {
        this.plan.opphevTrunkeringStart();
        this.saker.reberegnDetaljerForGrupper();
    }

    opphevTrunkeringSlutt() {
        this.plan.opphevTrunkeringSlutt();
        this.saker.reberegnDetaljerForGrupper();
    }

    lastAlleGrupperinger(gruppeId: string) {
        if (this.saker.alleGrupperingerVises(gruppeId)) return; //grupperinger allerede lastet

        InnlastingsindikatorKontroller.visIndikator(this.$scope.$root);
        this.saker.visAlleGrupperinger(gruppeId, []); //singalierer at grupperinger er lastet
        this.hentGrupperinger(gruppeId, this.filter.gruppering)
          .then(grupperinger => this.saker.visAlleGrupperinger(gruppeId, grupperinger))
          .finally(() => InnlastingsindikatorKontroller.skjuleIndikator(this.$scope.$root))
    }

    gaaTilPlanvisning() {
        this.deaktiverSakslisteVisningsmodus();
    }

    toggleListeSakerKnyttetTilGruppering(saksgruppeInfo: SaksgruppeInfo) {
        if (this.erSakslisteVisningsmodus() && this.saker.valgtSaksgruppeInfo.saksgruppeId == saksgruppeInfo.saksgruppeId)
            this.deaktiverSakslisteVisningsmodus();
        else
            this.aktiverSakslisteVisningsmodus(saksgruppeInfo.gruppeId, saksgruppeInfo.saksgruppeId);
    }

    visProtokollbehandlinger(gruppeId: GruppeId) {
        scrollTilTopp(this.$element.find('.wdk-planer'))
        this.aktiverListProtokollbehandlingerVisningsmodus(gruppeId);
    }

    erVisProtokollbehandlingerAktivForGruppe(gruppeId: GruppeId) {
        return this.erProtokollbehandlingerVisningsmodus() && this.protokollbehandlingerUtvalg.gruppeId == gruppeId;
    }

    erMatriseVisningsmodus() {
        return this.visningsmodus == 'matrise';
    }

    erSakslisteVisningsmodus() {
        return this.visningsmodus == 'saksliste';
    }

    erProtokollbehandlingerVisningsmodus() {
        return this.visningsmodus == 'protokollbehandlinger';
    }

    valgtSaksgruppeTittel() {
        switch (this.filter?.gruppering) {
            case l.SaksgrupperingPlan.tema:
                ///tittel på saksgruppetype, brukt bla i uttrykket 'viser saker knyttet til tema ..'
                return this.gettextCatalog.getString('tema');
            case l.SaksgrupperingPlan.sakstype:
                ///tittel på saksgruppetype, brukt bla i uttrykket 'viser saker knyttet til sakstype ..'
                return this.gettextCatalog.getString('sakstype');
            case l.SaksgrupperingPlan.ansvarlig:
                ///tittel på saksgruppetype, brukt bla i uttrykket 'viser saker knyttet til saksansvarlig ..'
                return this.gettextCatalog.getString('saksansvarlig');
        }
    }

    aapneFilterValg() {
        this.$scope.$root.$broadcast(DashboardFilterKontroller.eventer.visFilter);
    }

    gaaTilOpprettPlan(gruppeinfo: Gruppeinfo) {
        this.navigasjon.gåTilOpprettPlanMedPeriodeValgt(gruppeinfo.gruppe.id, this.filter.periode);
    }

    klikkPaaAarshjulinnslag(innslag: l.ÅrshjulInnslagModell) {
        RedigerÅrshjulinnslagDialog.visÅrshjulinnslagUtenforÅrsplankontekstDialog(innslag, this.$mdDialog)
          .then(respons => {
              this.navigasjon.gåTilÅrshjul();
          })
          .catch(_.noop); //bruker kansellerte dialog
    }

    $onInit(): void {
        debug("$onInit")
        //dersom saksliste er forespurt sørger vi her for at ikke møte-matrisen vises mens data lastes
        if (this.lesPersistertValgtSaksgruppeInfo() != null)
            this.visningsmodus = 'saksliste';

        this.$window.addEventListener('resize', this.resizeLytter);
    }

    $onChanges(onChangesObj: IOnChangesObject): void {
        const endretFilter: l.DashboardFiltervalg = onChangesObj['filter'].currentValue;
        //ved enkelte tilfeller (feks ved bytte mellom faner vs relasting av side) er onChangesObj['filter'].previousValue == UNINITIALIZED_VALUE, oversetter dette to undefined
        const opprinneligFilter: l.DashboardFiltervalg = onChangesObj['filter'].isFirstChange() ? undefined : onChangesObj['filter'].previousValue;
        if (!endretFilter) return;

        InnlastingsindikatorKontroller.visIndikator(this.$scope.$root);
        this.laster = true;
        this.filterEndret(endretFilter, opprinneligFilter)
          .finally(() => {
              InnlastingsindikatorKontroller.skjuleIndikator(this.$scope.$root);
              this.laster = false;
          });
    }

    $onDestroy(): void {
        this.$window.removeEventListener('resize', this.resizeLytter);
    }


    static serialisertValgtSaksgruppeInfo(spesifikasjon: PersistertValgtSaksgruppeInfo): string {
        return angular.toJson(spesifikasjon);
    }

    //hjelpemetoder

    private filterEndret(nyttFilter: l.DashboardFiltervalg, opprinneligFilter: l.DashboardFiltervalg): IPromise<any> {
        this.filter = nyttFilter; //strengt tatt ikke nødvendig..
        debug("filterEndret", nyttFilter, opprinneligFilter);

        this.periodeTittel = DashboardFilterKontroller.periodeTittel(this.filter.periode);
        this.viserInnevaerendePlan = DatoPerioder.inneholderNå(this.filter.periode);

        //last alle data på nytt dersom dette er første gang filter settes eller perioden er endret
        if (!opprinneligFilter) {
            this.nårMøterErLastet([]); //for å kunne tegne ut en tom plan (populert med måneder men ingen møter)
            return this.lastData().then(() => this.initIntroJs());
        }
        if (!_.isEqual(opprinneligFilter.periode, nyttFilter.periode))
            return this.periodeEndret();

        const promiser: IPromise<void>[] = [];

        //dersom nye grupper er lagt til gruppeutvalget
        const nyeGrupper = _(nyttFilter.gruppeIder).difference(opprinneligFilter.gruppeIder).value();
        if (!_.isEmpty(nyeGrupper))
            promiser.push(this.lastYtterligereGrupperOgMøter(nyeGrupper));

        //dersom kun grupper er fjernet fra gruppeutvalget
        const fjernedeGrupper = _(opprinneligFilter.gruppeIder).difference(nyttFilter.gruppeIder).value();
        if (!_.isEmpty(fjernedeGrupper))
            this.grupperFjernet(fjernedeGrupper);

        //dersom gruppering er endret
        if (!_.isEqual(opprinneligFilter.gruppering, nyttFilter.gruppering))
            this.grupperingEndret();

        //dersom visSaksdetaljer er endret
        if (!_.isEqual(opprinneligFilter.visSaksdetaljer, nyttFilter.visSaksdetaljer))
            this.visSaksdetaljerEndret();

        //dersom visAarshjulinnslag er endret
        if (!_.isEqual(opprinneligFilter.visAarshjulinnslag, nyttFilter.visAarshjulinnslag))
            this.visAarshjulinnslagEndret();

        //endring av visningsvalg trenger vi ikke å reagere på
        return this.$q.all(promiser);
    }

    private lastData(): IPromise<any> {
        debug("lastData");
        this.årshjulinnslagLaster = this.lastÅrshjuleinnslag(this.filter.gruppeIder);
        return this.$q.all([this.lastGrupperOgMøter(), this.årshjulinnslagLaster]);
    }

    private lastMøter(gruppeIder: string[]): IPromise<l.MøteModellEnkel[]> {
        debug("lastMøter", gruppeIder)
        return this.møteRes.finnMøterTilhørendeGrupperIPerioden(this.filter.periode.start, this.filter.periode.slutt, gruppeIder).$promise;
    }

    private lastÅrshjuleinnslag(gruppeIder: string[]): IPromise<{ [gruppeId: string]: l.ÅrshjulInnslagModell[] }> {
        debug("lastÅrshjuleinnslag", gruppeIder)
        if (!this.filter.visAarshjulinnslag) {
            //returner tomme innslaglister for alle forespurte grupper
            const resultat = _.zipObject(gruppeIder, gruppeIder.map(g => []));
            return this.$q.resolve(resultat);
        }
        //@todo tilpasset serverkall - som laster alle innslag for angitte grupper i ett kall
        return this.$q.all(
          gruppeIder.map(gruppeId => this.lastÅrshjulinnslagMem(gruppeId).$promise)) //lastÅrshjuleinnslagMem cacher - data lastes kun fra server dersom ikke lastet tidligere
          .then(innslagPerGruppe => _.zipObject(gruppeIder, innslagPerGruppe));
    }

    private inkluderteGrupper(): l.EnkelGruppeModell[] {
        return this.kontekst.autentiserteGrupper()
          .filter(gruppe => _(this.filter.gruppeIder).includes(gruppe.id));
    }

    private lastGrupperOgMøter(): IPromise<void> {
        const saksgruppeInfo = this.lesPersistertValgtSaksgruppeInfo();
        const ekspanderteGrupper = saksgruppeInfo == null ? this.lesPersistertEkspanderteGrupperUtvalg() : [saksgruppeInfo.gruppeId];

        debug('lastGrupperOgMøter', saksgruppeInfo, ekspanderteGrupper)
        return this.lastMøter(this.inkluderteGrupper().map(gruppe => gruppe.id))
          .then((møter: l.MøteModellEnkel[]) => {
              this.nårMøterErLastet(møter);
              //last detaljer for ekspanderte grupper
              return this.lastDetaljerForGrupper(ekspanderteGrupper);
          })
          //init valgtSaksgruppeInfo dersom vi skal vise saksliste for spesifikk gruppering
          .then(() => {
              if (saksgruppeInfo == null) return;
              if (saksgruppeInfo.saksgruppeType == 'protokollbehandlinger')
                  this.aktiverListProtokollbehandlingerVisningsmodus(saksgruppeInfo.gruppeId);
              else
                  this.aktiverSakslisteVisningsmodus(saksgruppeInfo.gruppeId, saksgruppeInfo.id);
          });
    }

    private lastYtterligereGrupperOgMøter(nyeGrupper: string[]): IPromise<void> {
        this.saker.grupperLagtTil(nyeGrupper.map(id => this.kontekst.finnAutentiserteGruppe(id)))
        this.årshjulinnslagLaster = this.lastÅrshjuleinnslag(this.filter.gruppeIder);
        return this.lastMøter(nyeGrupper).then((møter) => {
            this.nårMøterErLastet(_.concat(this.møter, møter));
        });
    }

    private grupperFjernet(fjernedeGrupper: string[]) {
        this.saker.grupperFjernet(fjernedeGrupper);
        const møter = this.møter.filter(m => !_.includes(fjernedeGrupper, m.eiendeGruppeId));
        this.nårMøterErLastet(møter);
    }

    private nårMøterErLastet(møter: l.MøteModellEnkel[]) {
        this.møter = møter;
        this.initPlanmodell();
        this.initSakermodell();
    }

    private initPlanmodell() {
        var gjeldendeTidssone = gjeldendeTidssoneStatisk(Tidssoneinformasjon.fraJavaTimeZone(this.kontekst.autentisertBruker().tidssone));
        this.plan = new MøterIPlanModell(
          new Klokke(gjeldendeTidssone),
          gjeldendeTidssone,
          () => this.årshjulinnslagLaster,
          () => this.kontainerbredde());
        this.plan.initModell(this.filter.periode, this.møter, this.inkluderteGrupper())
          .then(() => this.scrollTilNåPos());
    }

    private initSakermodell() {
        this.saker = new SakerIPlanModell(
          this.inkluderteGrupper(),
          this.filter.gruppering,
          this.filter.visSaksdetaljer,
          møteId => this.plan.møteInfoForMøte(møteId),
          this.kontekst);
        this.saker.initGrupper(); //@todo skille grupper ut i egen modell - nå er saker og grupper i samme
        this.saker.initMøter(this.møter);
    }

    /** Håndterer at bruker endret størrelse på nettleservindu */
    private håndterEndringIVindusstørrelse() {
        //trenger kun å reagere dersom vi er i matrise-visning
        if (this.visningsmodus == 'saksliste') return;

        //krever en full initialisering av modell for å ta hensyn til ny vindusstørrelse
        //dette fordi antallet møter vi har plass til å vise kan ha endret seg - og dette er
        //krever total reberegning av viste-måneder-vinduet/møter.
        this.initPlanmodell();

        //etter at månedinfo i MøterIPlanModell er beregnet må sakerinfo reberegnes - for de grupper
        //detaljer (saker) vises for
        this.saker.ekspanderteGrupper().forEach(gruppeId =>
          this.saker.initDetaljerForGruppe(gruppeId, this.lastedeMøtedetaljer[gruppeId]));
    }

    private kontainerbredde() {
        return this.$element.innerWidth();
    }

    /** sørger for å horisontal-scrolle slik vertikal "nå" markør er i senter */
    private scrollTilNåPos() {
        if (!this.plan.naaPos) return;
        this.$timeout(() => {
            let scrollkontainer = this.$element.find('#wdkp-rad-innhold');
            scrollkontainer.scrollLeft(this.plan.naaPos - (scrollkontainer.width() / 2));
        }, 100);
    }

    /** håndterer at periode er endret i filter-valg */
    private periodeEndret(): IPromise<any> {
        if (this.erProtokollbehandlingerVisningsmodus())
            this.visProtokollbehandlinger(this.protokollbehandlingerUtvalg.gruppeId);
        return this.lastGrupperOgMøter();
    }

    /** håndterer at gruppering (tema/sakstype/ansvarlig) er endret i filter-valg */
    private grupperingEndret() {
        this.saker.nullstillAlleGrupperingerCache(); //nullstill lastede "alle grupperinger" - disse er ikke lenger gyldige
        this.deaktiverSakslisteVisningsmodus(); //gir ikke mening å forbli i saksliste modus når gruppering er endret
        this.saker.oppdaterValg(this.filter.gruppering, this.filter.visSaksdetaljer);
    }

    /** håndterer at visning av saksdetaljer er endret i filter-valg */
    private visSaksdetaljerEndret() {
        this.saker.oppdaterValg(this.filter.gruppering, this.filter.visSaksdetaljer);
    }

    /** håndterer at visning av årshjulinnslag er endret i filter-valg */
    private visAarshjulinnslagEndret() {
        debug("visAarshjulinnslagEndret")
        this.årshjulinnslagLaster = this.lastÅrshjuleinnslag(this.filter.gruppeIder);
        this.plan.initÅrshjul();
    }

    private lastDetaljerForGrupper(gruppeIder: string[]): IPromise<any> {
        const promiser: IPromise<void>[] = gruppeIder
          .filter(id => this.saker.inneholderGruppe(id))
          .map(id => this.lastMøtedetaljerForGruppe(id)
            .then(møter => this.saker.initDetaljerForGruppe(id, møter)));

        return this.$q.all(promiser);
    }

    private lastMøtedetaljerForGruppe(gruppeId: string): IPromise<l.MøteModell[]> {
        debug("lastMøtedetaljerForGruppe", gruppeId)
        return this.møteRes.finnMøterTilhørendeGruppeIPerioden(this.filter.periode.start, this.filter.periode.slutt, gruppeId).$promise
          .then(møtedetaljer => {
              this.lastedeMøtedetaljer[gruppeId] = møtedetaljer;
              return møtedetaljer;
          });
    }

    private hentGrupperinger(gruppeId: string, gruppering: string): IPromise<GrupperingsEntitet[]> {
        switch (gruppering) {
            case l.SaksgrupperingPlan.tema:
                return this.temaRes.alleTema(gruppeId).$promise; //@todo luke bort arkiverte som ikke er i bruk i planen?
            case l.SaksgrupperingPlan.sakstype:
                return this.sakstypeRes.tilgjengeligeSakstyper(gruppeId).$promise;
            case l.SaksgrupperingPlan.ansvarlig:
                return this.gruppeRes.hent(gruppeId).$promise
                  .then(gruppe => gruppe.medlemmer);
        }
    }

    private persisterEkspanderteGrupperUtvalg() {
        debug('persisterEkspanderteGrupperUtvalg');
        const ekspanderteGrupper = this.saker.ekspanderteGrupper();
        this.$location.replace(); //for å unngå at vi legger til et nytt element i navigasjonshistorikken
        this.$location.search("d", angular.toJson(ekspanderteGrupper));
        this.kontekst.oppdaterBrukervalg({dashboardEkspanderteGrupper: ekspanderteGrupper});
    }

    private lesPersistertEkspanderteGrupperUtvalg(): string[] {
        let ekspanderteGrupper: string[] = fraJson(this.$state.params["d"]);

        if (!_.isArray(ekspanderteGrupper))
            ekspanderteGrupper = this.kontekst.brukervalg().dashboardEkspanderteGrupper

        return ekspanderteGrupper
          .filter(gruppeId => this.saker.grupperinfo.some(gruppe => gruppe.gruppe.id === gruppeId));
    }

    private persisterValgtSaksgruppeInfo() {
        debug('persisterValgtSaksgruppeInfo');
        let info: PersistertValgtSaksgruppeInfo = this.saker.valgtSaksgruppeInfo == null ? null : {
            gruppeId: this.saker.valgtSaksgruppeInfo.gruppeId,
            saksgruppeType: this.saker.valgtSaksgruppeInfo.saksgruppeType, //finnes også i filter.gruppering
            id: this.saker.valgtSaksgruppeInfo.saksgruppeId
        };

        //siden vi piggybacker protokollbehandlinger-moduset på ValgtSaksgruppeInfo
        if (this.erProtokollbehandlingerVisningsmodus())
            info = {
                gruppeId: this.protokollbehandlingerUtvalg.gruppeId,
                saksgruppeType: 'protokollbehandlinger',
                id: null
            };

        this.$location.replace(); //for å unngå at vi legger til et nytt element i navigasjonshistorikken
        this.$location.search('f', PlanerKontroller.serialisertValgtSaksgruppeInfo(info));
    }

    private lesPersistertValgtSaksgruppeInfo(): PersistertValgtSaksgruppeInfo {
        let info: PersistertValgtSaksgruppeInfo = fraJson(this.$state.params['f']);
        if (info == null) return null;// intent å gjøre
        return info;
    }

    private aktiverSakslisteVisningsmodus(gruppeId: string, grupperingsentitetId: string) {
        if (this.saker.aktiverSakslisteVisningsmodus(gruppeId, grupperingsentitetId)) {
            this.visningsmodus = 'saksliste';
            this.persisterValgtSaksgruppeInfo();

        } else
          //gå til matrisevisningsmodus dersom vi ikke finner forespurt saksgruppe
            this.deaktiverSakslisteVisningsmodus();
    }

    private deaktiverSakslisteVisningsmodus() {
        this.saker.deaktiverSakslisteVisningsmodus();
        this.visningsmodus = 'matrise';
        this.persisterValgtSaksgruppeInfo();
    }

    private aktiverListProtokollbehandlingerVisningsmodus(gruppeId: string) {
        const gruppe = this.saker.grupperinfo.find(info => info.gruppe.id == gruppeId)?.gruppe;

        //gå til matrisevisningsmodus dersom vi ikke finner forespurt saksgruppe
        if (erNil(gruppe)) {
            this.deaktiverListProtokollbehandlingerVisningsmodus();
            return;
        }

        this.visningsmodus = 'protokollbehandlinger';
        this.protokollbehandlingerUtvalg = {
            gruppeId: gruppeId,
            periode: ZonedDateTimePeriodeLukket.fraDate(this.filter.periode),
            gruppe: gruppe
        };

        this.persisterValgtSaksgruppeInfo();
    }

    private deaktiverListProtokollbehandlingerVisningsmodus() {
        //siden vi piggybacker protokollbehandlinger-moduset på ValgtSaksgruppeInfo
        this.saker.deaktiverSakslisteVisningsmodus();
        this.visningsmodus = 'matrise';
        this.persisterValgtSaksgruppeInfo();
    }

    private initIntroJs() {
        this.kontekst.erLastetFraServer().then(() => {
            const visSkriverettigheterTekst = this.kontekst.inneharTilgangsrolleINoenGruppe(l.TilgangsrolleMedlem.skrive);
            this.introJs.visIntroForsinket(
              this.introJs.nyIntroduksjon('dashboard.oversikt')
                .leggTilSteg(
                  1,
                  {
                      title: this.gettextCatalog.getString('Neste møte'),
                      intro: visSkriverettigheterTekst ?
                        this.gettextCatalog.getString('Dette er en snarvei til møteinfo og sakslisten for neste møte.<br /><br />Her administrerer du alt som har med møtet å gjøre, både før, under og etter møtet.') :
                        this.gettextCatalog.getString('Dette er en snarvei til møteinfo og sakslisten for neste møte.'),
                      element: '[data-tips-id="hovedmeny-neste-moete"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  2,
                  {
                      title: this.gettextCatalog.getString('Beslutninger'),
                      intro: this.gettextCatalog.getString('Liste over alle beslutninger, forslag til beslutninger og tilknytning til saker. Du kan filtrere på gruppe og oppgavestatus.'),
                      element: '[data-tips-id="hovedmeny-beslutninger"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  3,
                  {
                      title: this.gettextCatalog.getString('Oppgaver'),
                      intro: this.gettextCatalog.getString('Oversikt over alle oppgaver, med frist, status, og eventuell tilknytning. Du kan kommentere på oppgaver, legge til som favoritt og oppdatere status.'),
                      element: '[data-tips-id="hovedmeny-oppgaver"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  4,
                  {
                      title: this.gettextCatalog.getString('Kommentarer'),
                      intro: this.gettextCatalog.getString('Liste over dine og andres kommentarer på saker, oppgaver og beslutninger. Her kan du svare på kommentarer.'),
                      element: '[data-tips-id="hovedmeny-kommentarer"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  5,
                  {
                      title: this.gettextCatalog.getString('Bibliotek'),
                      intro: visSkriverettigheterTekst ?
                        this.gettextCatalog.getString('Biblioteket er et arkiv hvor du kan opprette mapper og laste opp dokumenter. Her kan du styre tilgang, sende til signering, annotere og legge til som favoritt.') :
                        this.gettextCatalog.getString('Biblioteket er et arkiv for andre dokumenter som kan være relevante for gruppen.<br /><br />Biblioteket administreres av gruppeadministrator.'),
                      element: '[data-tips-id="hovedmeny-arkiv"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  6,
                  {
                      title: this.gettextCatalog.getString('Grupper'),
                      intro: visSkriverettigheterTekst ?
                        this.gettextCatalog.getString('Oversikt over gruppene dine. Du kan administrere gruppene dine, og lage nye grupper.<br /><br />Du har også tilgang til din brukerprofil, dine avtaler, og dine personlige sikkerhets- og meldingsinnstillinger.') :
                        this.gettextCatalog.getString('Oversikt over gruppene dine. Her kan du lage nye avtaler og grupper.<br /><br />Du har også tilgang til din brukerprofil, dine avtaler, og dine personlige sikkerhets- og meldingsinnstillinger.'),
                      element: '[data-tips-id="hovedmeny-grupper"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  7,
                  {
                      title: this.gettextCatalog.getString('Hjem'),
                      intro: visSkriverettigheterTekst ?
                        this.gettextCatalog.getString('Dette er startsiden med oversikt over gjøremål og alle møtene dine.<br /><br />Her finner du status på dokumenter til signering, og muligheten til å sende ut påminnelse.<br /><br />Du finner også en oversikt over gruppemedlemmers forfalte oppgaver og status på eventuelle avstemninger.') :
                        this.gettextCatalog.getString('Her finner du dokumenter til signering, oppgavene dine og dine pågående avstemninger.'),
                      element: '[data-tips-id="hovedmeny-dashboard"]',
                      position: "right"
                  }
                )
                .leggTilSteg(
                  8,
                  {
                      title: this.gettextCatalog.getString('Aktivitetspanel'),
                      intro: this.gettextCatalog.getString('Her ser du dine dokumenter til signering, oppgaver og avstemninger.'),
                      element: "dashboard-status",
                      position: "bottom"
                  }
                )
                .leggTilSteg(
                  9,
                  {
                      title: this.gettextCatalog.getString('Visning av møter'),
                      intro: visSkriverettigheterTekst ?
                        this.gettextCatalog.getString('Her kan du endre visningsmodus for møtene dine.<br /><br />Årsplanen er en årskalender som viser alle møter for valgte grupper.<br /><br />Møtelisten viser møtene i en tidslinje.<br /><br />Årshjulet viser møtene i et årshjul. Her kan du i tillegg legge inn aktiviteter som gjentas årlig.') :
                        this.gettextCatalog.getString('Her kan du endre visningsmodus for møtene dine.<br /><br />Årsplanen er en årskalender som viser alle møter for valgte grupper.<br /><br />Møtelisten viser møtene i en tidslinje.<br /><br />Årshjulet viser møtene i et årshjul.'),
                      element: '[data-tips-id="dashboard-moete-visning"]',
                      position: "bottom"
                  }
                )
                .leggTilSteg(
                  10,
                  {
                      title: this.gettextCatalog.getString('Årsplan'),
                      intro: visSkriverettigheterTekst ?
                        this.gettextCatalog.getString('Her ser du alle møtene dine. Du kan enkelt lage møter ved å trykke på “Nytt møte” i toppmenyen.<br /><br />Når du har en årsplan kan du trykke rett i måneden for å opprette nytt møte.') :
                        this.gettextCatalog.getString('Her ser du alle møtene dine.'),
                      element: "wm-dashboard-planer",
                      position: "top"
                  }
                )
                .leggTilSteg(
                  11,
                  {
                      title: this.gettextCatalog.getString('Filterpanel'),
                      intro: this.gettextCatalog.getString('I filterpanelet kan du blant annet velge hvilke grupper du ser i årsplanen, møtelisten og årshjulet.'),
                      element: "wm-dashboard-filter",
                      position: "bottom"
                  },
                )


                .leggTilSteg(
                  12,
                  {
                      title: this.gettextCatalog.getString('Min side'),
                      intro: this.gettextCatalog.getString('Her ligger din profil, dine avtaler, og dine personlige sikkerhets- og meldingsinnstillinger. Her kan du endre e-postadressen din, telefonnummer, navn, bilde og systemspråk.'),
                      element: '[data-tips-id="toppbanner-minside"]',
                      position: "left"
                  }
                ),
              1000
            );
        });
    }
}


export interface PersistertValgtSaksgruppeInfo {
    gruppeId: string;
    saksgruppeType: string;
    id: string;
}
